import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ApplicationTypesComponent } from "./components/application-types/application-types.component";
import { BrokerageComponent } from "./components/home/brokerage/brokerage";
import { CommunityComponent } from "./components/home/community/community";
import { HomeComponent } from "./components/home/home.component";
import { MarketplaceComponent } from "./components/home/marketplace/marketplace.component";
import { ShowroomComponent } from "./components/home/showroom/showroom.component";
import { OrganizationComponent } from "./components/organization/organization.component";
import { OrganizationsComponent } from "./components/organizations/organizations.component";
import { TechnologiesComponent } from "./components/technologies/technologies.component";
import { TechnologyComponent } from "./components/technology/technology.component";

const appRoutes: Routes = [
	{
		path: "", component: HomeComponent, children: [
			{ path: "", component: MarketplaceComponent },
			{ path: "brokerage", component: BrokerageComponent },
			{ path: "community", component: CommunityComponent },
			{ path: "showroom", component: ShowroomComponent },
		],
	},
	{ path: "applicationTypes/:id", component: ApplicationTypesComponent },
	{ path: "organizations", component: OrganizationsComponent },
	{ path: "organization/:id", component: OrganizationComponent },
	{ path: "technologies/:id", component: TechnologiesComponent },
	{ path: "technology/:id", component: TechnologyComponent },
] as Routes;

@NgModule({
	imports: [
		RouterModule.forRoot(appRoutes),
	],
	exports: [
		RouterModule,
	],
})
export class AppRoutingModule implements NgModule { }



// WEBPACK FOOTER //
// ./Frontend/src/app/app-routing.module.ts